import { cn } from "@qw/ui";

/**
 * The chrome every book row shares: hover/focus background, the hairline divider that starts where
 * the insured name starts, and the current-route ring. What sits inside it varies — a full book row
 * carries a state icon, a date and a pin; a search result carries only a name.
 */
export const BookRow = ({ className, ...props }: React.ComponentProps<"div">) => (
  <div
    className={cn(
      "group/book-row relative grid h-8 items-center pr-1 rounded-sm transition-colors hover:bg-foreground/5 focus-within:bg-foreground/5",
      "after:absolute after:-right-1 after:bottom-0 after:left-[--spacing(22)] after:h-px after:bg-border/35 last:after:hidden",
      "has-aria-current:inset-ring-1 has-aria-current:inset-ring-primary/35 has-aria-current:text-primary has-aria-current:after:bg-primary/25",
      className
    )}
    {...props}
  />
);
